import React, { Component } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import projectStore from "../stores/projectStore";
import { observer } from "mobx-react";
import { FaCaretRight, FaCaretDown, FaSave } from "react-icons/fa";
import generalStore from "../stores/generalStore";
import CreateProjectModalV2 from "../modals/projectModals/CreateProjectModalV2";
import Wave from "../components/Wave";
import {
  LuFolderPlus,
  LuLayoutGrid,
  LuHeart,
  LuPlay,
  LuPause,
  LuInfo
} from "react-icons/lu";
import {
  AddNewTalentColoredIcon,
  CloudIconColored,
  SearchColoredIcon,
  ShareIcon,
} from "../assets/icons";
import Button from "../components/Button";
import {
  LuCopy,
  LuExternalLink,
  LuFilePlus,
  LuFolder,
  LuFolderOpen,
  LuMail,
  LuPauseCircle,
  LuPlayCircle,
  LuPlaySquare,
  LuTrash,
} from "react-icons/lu";
import voiceStore from "../stores/voiceStore";
import SearchNavV2 from "../components/SearchNavV2";
import {
  FaEdit,
  FaPlus,
  FaShare,
  FaTrash,
  FaMinus,
  FaUndo,
  FaWhatsapp,
  FaTimes,
  FaStar,
  FaStarHalfAlt,
  FaRegStar

} from "react-icons/fa";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { toast } from "react-toastify";
import { PiWarningCircleFill } from "react-icons/pi";
import { Bars } from "react-loader-spinner";
import { BsPersonFillCheck } from "react-icons/bs";
import { Tooltip } from "react-tooltip";
import axios from "axios";
import moment from "moment";
import { ClipLoader } from 'react-spinners'; 

function withRouter(Component) {
  return function WrapperComponent(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    
    return (
      <Component
        {...props}
        location={location}
        params={params}
        navigate={navigate}
      />
    );
  };
}

const Dashboard = observer(
  class Dashboard extends Component {
    constructor(props) {
      super(props);
      this.state = {
        expandedGroups: {
          0: true,
        },
        openFolders: {},
        folderTree: this.convertToFolderTree(voiceStore.searchResults),
        rightPanelFolders: [],
        newFolderName: "NewFolder",
        showDeleteModal: false,
        showEditProjectModal : false,
        showEditClientModal: false,
        showDeleteClientModal : false,
        showProfileDetailModal: false,
        showShareProjectModal: false,
        shareProjectLink: null,
        projectName: null,
        loading: false,
        isMobile: window.innerWidth <= 767,
        suggestions : [],
        years:[],
        currDeleteProject : null,
        currDeleteClient : null,
        currEditProject : null,
        currEditProjectName : null,
        currEditClient : null,
        currEditClientName : null,
        createNewProjectModalVisible : false,
        showSaveProject : false,
        currOpenProfile : null,
        highlightedIndex: -1
      };
      this.setInitialSearchData();
      this.dropdownRef = React.createRef();
      this.modalRef = React.createRef();
      
    }
   formatData = (value) => {
    if (!value || value === "null" || value === "undefined" || value === '""') {
      return "NA";
    }
    return value;
  };
   calculateAge = (date) => {
      const birthDate = moment(date);
      const today = moment();
      const age = today.diff(birthDate, "years");
      return isNaN(age) ? "NA" : age;
    };
    setShowSaveProject = (value)=>
    {
      this.setState({ showSaveProject : value});
    };

  handleSaveProject = () => {

 let projectChanges = [];
 const { rightPanelFolders } = this.state;

  for (const yearFolder of rightPanelFolders) {
    for (const clientFolder of yearFolder.children || []) {
      for (const projectFolder of clientFolder.children || []) {

                  const haveChanges = projectFolder.children.some((folder) => {
                    const folderChanged = folder.isNew || folder.isEditing || folder.isDeleted;
                    const sampleChanged = folder.children?.some((voiceSample) =>
                      voiceSample.isDeleted || voiceSample.isNew
                    );
                    return folderChanged || sampleChanged;
                  });
                  if(haveChanges)
                  {
                     projectChanges.push(projectFolder);
                  }



      }
    }

  }

  if(projectChanges)
  {
    for(const projectFolder of projectChanges)
    {
      const folderNames = projectFolder.children.map((folder) => folder.name);
                  const duplicateNames = folderNames.filter(
                    (name, index) => folderNames.indexOf(name) !== index
                  );

                  console.log("Folder names:", folderNames); // Debug log
                  console.log("Duplicate folder names:", duplicateNames); // Debug log

                  const folderIds = projectFolder.children.map((folder) => folder.id);
                  const duplicateIds = folderIds.filter(
                    (id, index) => folderIds.indexOf(id) !== index
                  );

                  console.log("Folder IDs:", folderIds); // Debug log
                  console.log("Duplicate folder IDs:", duplicateIds); // Debug log

                  const folderChildren = projectFolder.children.flatMap((folder) =>
                    folder.children.map((child) => child.sample_id)
                  );
                  const duplicateChildren = folderChildren.filter(
                    (id, index) => folderChildren.indexOf(id) !== index
                  );

                  console.log("Child sample IDs:", folderChildren); // Debug log
                  console.log("Duplicate child sample IDs:", duplicateChildren); // Debug log

                  this.setState({ loading: true });

                  if (duplicateNames.length > 0 || duplicateIds.length > 0 || duplicateChildren.length > 0) {
                    toast.error(
                      "There are duplicate folder names, IDs, or child sample IDs. Please resolve them."
                    );
                    this.setState({ loading: false });
                  } else {
                    projectStore
                      .saveProject({
                        projectId: projectFolder.value,
                        folders: projectFolder.children,
                      })
                      .then((data) => {
                        console.log("Save successful. Response data:", data); // Debug log
                        this.setState({ loading: false });
                        this.toggleFolderByNode(projectFolder);
                        this.setShowSaveProject(false);
                      })
                      .catch((error) => {
                        console.error("Save failed. Error:", error); // Debug log
                        this.setState({ loading: false });
                      });
                  }

    }
  }
};
    toggleShareProjectModal = (bool) => {
      if (bool === false) {
        this.setState({ showShareProjectModal: false });
        return;
      }

      let url =
        process.env.REACT_APP_REDIRECT_URL +
        "/shared-projects/view/" +
        this.props.params.projectId;

      this.setState({
        showShareProjectModal: !this.state.showShareProjectModal,
        shareProjectLink: url,
      });
    };
     
    toggleDeleteModal = () => {
      this.setState({ showDeleteModal: !this.state.showDeleteModal });
    };
    toggleDeleteClientModal = () => {
      this.setState({ showDeleteClientModal: !this.state.showDeleteClientModal });
    };
     toggleEditProjectModal = () => {
      this.setState({ showEditProjectModal: !this.state.showEditProjectModal });
    };
      toggleEditClientModal = () => {
      this.setState({ showEditClientModal: !this.state.showEditClientModal });
    };
    handleRenameProject= ()=>{
      const  { currEditProject, currEditProjectName } = this.state;
      if(currEditProject)
      {
          projectStore.updateProjectName(currEditProject.id, currEditProjectName)
          .then(()=>
          {
            this.setState((prevState) => {
    const updatedFolders = prevState.rightPanelFolders.map((folder) => {
      const updatedClients = folder.children.map((client) => {
        const updatedProjects = client.children.map((project) => {
            if (project.id === currEditProject.id) {
              return {
                ...project,
                name: currEditProjectName, // ✅ Rename here
              };
            }
            return project;



        });

        return {
          ...client,
          children: updatedProjects,
        };
      });

      return {
        ...folder,
        children: updatedClients,
      };
    });

    return {
      rightPanelFolders: updatedFolders,
    };
  });
              this.setState({ currEditProject : null, currEditProjectName : null});

          });
      }
      this.setState({ showEditProjectModal: false });
    }

      handleRenameClient= ()=>{
      const  { currEditClient, currEditClientName } = this.state;
      if(currEditClient)
      {
      }
    }

    handleDelete = () => {
  this.setState({ showDeleteModal: false });

  const { currDeleteProject, rightPanelFolders } = this.state;
  const payload = { projectId: currDeleteProject };

  projectStore.deleteProject(payload).then(() => {
    const updatedFolders = rightPanelFolders.map((yearFolder) => {
      const updatedClients = yearFolder.children.map((clientFolder) => {
        const updatedProjects = clientFolder.children
          .filter((project) => project.id !== payload.projectId);

        return {
          ...clientFolder,
          children: updatedProjects,
        };
      });

      return {
        ...yearFolder,
        children: updatedClients,
      };
    });

    this.setState({ rightPanelFolders: updatedFolders });
  });
};

     handleDeleteClient = () => {
      this.setState({ showDeleteClientModal:false });
      projectStore.deleteClient(
        {
            clientName : this.state.currDeleteClient.id,
            year: this.state.currDeleteClient.year
        }).then(() => {
        this.loadData();
      });;
      this.setState({ currDeleteClient : null });
    };
    refreshFolder = async (data) => {

    if (!projectStore.parentNode){
      this.loadData();
      return;
    }

  const { year, category, id } = projectStore.parentNode;

  const newProjectFolder = {
    id: data.projectId,
    name: data.projectName,
    value: data.projectId,
    type: "folder",
    category: "project",
    client: data.clientName,
    children: [],
  };
  if(category === "client")
  {
  const updatedFolders = this.state.rightPanelFolders.map((yearFolder) => {
    if (yearFolder.value !== year) return yearFolder;
    const updatedClients = (yearFolder.children || []).map((clientFolder) => {
      if (clientFolder.id !== id) return clientFolder;

      return {
        ...clientFolder,
        children: [...(clientFolder.children || []), newProjectFolder],
      };
    });

    return {
      ...yearFolder,
      children: updatedClients,
    };
  });
  projectStore.removeParentNode();
  this.setState({ rightPanelFolders: updatedFolders });
}else if(category === "year")
{
    this.state.rightPanelFolders.forEach((yearFolder)=>
    {
        if(yearFolder.value == year)
        {
            this.toggleFolderByNode(yearFolder);
            return;
        }
    })

}

};

checkProjectChanges = (data) => {
  const hasChanges = data.some((yearFolder) =>
    yearFolder.children?.some((clientFolder) =>
      clientFolder.children?.some((projectFolder) =>
        projectFolder.children?.some((subProjectFolder) => {
          if (subProjectFolder.isNew || subProjectFolder.isEditing || subProjectFolder.isDeleted) {
            return true;
          }
          return subProjectFolder.children.some(
            (voiceData) => voiceData.isDeleted || voiceData.isNew
          );
        })
      )
    )
  );


  this.setShowSaveProject(hasChanges);
};
    toggleFolder = (id) => {
       const newSearchResult = voiceStore.searchResults.map((item)=>{
        if(item.talent_id == id)
        {
            item.selected = !item.selected;
           
        }
        return item;
      });
      voiceStore.setSearchResults(newSearchResult);
      
     
    };

openAllFolders = () => {
  this.setState((prevState) => {
    const newOpenFolders = {};

    for (const key in prevState.openFolders) {
      newOpenFolders[key] = true;
    }

    return { openFolders: newOpenFolders };
  });
};

    toggleFolderByNode = async (node, isOpen) => {

  const { category, value, year, client } = node;

  const updatedFolders = [...this.state.rightPanelFolders];

  const updateState = () => {
    this.setState((prevState)=> (
      {
        rightPanelFolders: updatedFolders
      }));

  };

  const updateOpenFolders = () => {
    // this.setState((prevState) => ({
    //   openFolders: {
    //     ...prevState.openFolders,
    //     [node.id]: !prevState.openFolders[node.id],
    //   },
    // }));
  };
  

  if (category === "year") {
    const clientResponse = await projectStore.getClients(value);
    const uniqueClients = [...new Set(clientResponse)];

    const clients = uniqueClients.map((clientName) => ({
      id: clientName,
      name: clientName,
      value: clientName,
      type: "folder",
      category: "client",
      year: value, // Make sure `value` is defined
      children: [],
    }));
    updatedFolders.forEach((yearFolder) => {
      if (yearFolder.value === value) {
        yearFolder.isOpen = !yearFolder.isOpen;
        yearFolder.children = clients;

      }
    });

    updateState();
  } else if (category === "client") {
    const projectResponse = await projectStore.getProjects({
      clientName: value,
      year,
      limit: 1000,
    });

    const projects = projectResponse.map((project) => ({
      id: project.project_id,
      name: project.project_name,
      value: project.project_id,
      type: "folder",
      category: "project",
      client: value,
      children: [],
    }));

    updatedFolders.forEach((yearFolder) => {
      if (yearFolder.value === year) {
        yearFolder.children.forEach((clientFolder) => {
          if (clientFolder.value === value) {
            clientFolder.children = projects;
            clientFolder.isOpen = !clientFolder.isOpen;
          }
        });
      }
    });

    updateState();
  } else if (category === "project") {
    const projectDetails = await projectStore.getProjectDetails(value);

    const projectFolders = projectDetails.map((data) => ({
      id: data.folderId,
      name: data.folderName,
      value: data.folderId,
      type: "folder",
      category: "project-folder",
      project: value,
      children: (data.voiceModel || []).map((sample) => ({
        talent_id: sample.talentId,
        sample_id: sample.sampleId,
        name: sample.voiceName,
        type: "file",
        filePath: `${process.env.REACT_APP_BASE_URL}/${sample.samplePath}`,
        isDeleted: false,
        isClientSelected: sample.isClientSelected,
      })),
    }));

    updatedFolders.forEach((yearFolder) => {
      yearFolder.isOpen = false;
      yearFolder.children.forEach((clientFolder) => {
      
        if (clientFolder.value === client) {
          yearFolder.isOpen = !yearFolder.isOpen;
          clientFolder.children.forEach((projectFolder) => {
            if (projectFolder.value === value) {
              projectFolder.children = projectFolders;
              projectFolder.isOpen =  !projectFolder.isOpen;
            }else
            {
              projectFolder.isOpen = false;
            }
          });
        }else
        {
            clientFolder.isOpen = false;
            clientFolder.children.forEach((projectFolder) => {
              projectFolder.isOpen = false;
            
          });
        }
      });
    
    });

    updateState();
  }

  
};



    renderTree = (nodes) => {
  return (
    <ul className="flex flex-1 flex-col list-disc ml-4">
      {nodes.map((node) => (
        <li key={node.id} className="flex flex-col items-start mb-2">
          {node.type === "folder" ? (
            <>
              <div className="cursor-pointer flex items-center">
                <div
                  onClick={() => this.toggleFolder(node.id)}
                  className="flex items-center"
                >
                  {(node.isOpen) ? (
                    <LuFolderOpen className="mr-2" size={20} />
                  ) : (
                    <LuFolder className="mr-2" size={20} />
                  )}
                </div>

                <span className="font-normal text-sm" onClick={() => this.toggleFolder(node.id)}>
                  {node.name}
                </span>

                {/* ℹ️ Info icon to show profile detail */}
                <button
                  className="ml-2 text-gray-600 hover:text-blue-600"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      showProfileDetailModal: true,
                      currOpenProfile: node,
                    });
                  }}
                >
                  <LuInfo size={18} className="text-orange-500" />
                </button>
              </div>

              {(node.isOpen) && (
                <ul className="flex flex-1 flex-col w-[90%] ml-4">
                  {node.children.map((child) => (
                    <li className="flex w-full" key={child.sample_id}>
                      <this.FileItem file={child} />
                    </li>
                  ))}
                </ul>
              )}
            </>
          ) : (
            <this.FileItem file={node} />
          )}
        </li>
      ))}
    </ul>
  );
};



    renderTreeProjects = (nodes) => {
  return (
    <ul className="ml-4 space-y-2">
      {nodes.map((node, index) => (
        <li key={`${node.id}-${index}`}>
          {this.renderTreeNode(node)}
        </li>
      ))}
    </ul>
  );
};



renderTreeNode = (node) => {
  if (node.type === "folder") {
    
    const isOpen = node.isOpen; //this.state.openFolders[node.id];
    const isYearFolder = node.category === "year";
    const isProjectFolder = node.category === "project";
    const isClientFolder = node.category === "client";
     if (node.category !== "project-folder") {
      return (
        <div className="flex flex-col">
          <div
            className="cursor-pointer flex items-center rounded-md group"
            onClick={() => this.toggleFolderByNode(node)}
          >
            {isOpen ? (
    <LuFolderOpen
  className={`mr-2 ${
    isProjectFolder
      ? "text-red-500"
      : isClientFolder
      ? "text-green-500"
       : isYearFolder
      ? "text-blue-500"
      : ""
  }`}
  size={20}
/>  ) : (
               <LuFolder
  className={`mr-2 ${
    isProjectFolder
      ? "text-red-500"
      : isClientFolder
      ? "text-green-500"
       : isYearFolder
      ? "text-blue-500"
      : ""
  }`}
  size={20}
/>
            )}

            <span className="cursor-pointer">{node.name}</span>

            {isProjectFolder && (
              <div
                className="flex space-x-2 ml-4"
                onClick={(e) => e.stopPropagation()} // ✅ Prevents parent toggle
              >
                <FaEdit
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.showEditProjectPopup(node)}
                />
                 { isOpen && (<FaPlus
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.handleCreateFolder(node.id)}
                />)
                 }
                <FaShare
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.handleShareProject(node.id)}
                />
                <FaTrash
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.handleDeleteProject(node)}
                />

              </div>
            )}
             {isClientFolder && (
              <div
                className="flex space-x-2 ml-4"
                onClick={(e) => e.stopPropagation()} // ✅ Prevents parent toggle
              >
                 {/* <FaEdit
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.showEditClientPopup(node)}
                /> */}
                { isOpen && (<FaPlus
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.handleCreateProjectFolder(node)}
                />)
                }

                <FaTrash
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.showDeleteClientPopup(node)}
                />

              </div>
            )}
            {isYearFolder && (
              <div
                className="flex space-x-2 ml-4"
                onClick={(e) => e.stopPropagation()} // ✅ Prevents parent toggle
              >
                 { isOpen && (<FaPlus
                  className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  onClick={() => this.handleCreateClientFolder(node)}
                />) }



              </div>
            )}
          </div>

          {isOpen && node.children && (
            <ul className="ml-6 mt-1 space-y-1 border-l border-gray-300 pl-2">
              {node.children.map((child) => (
                <li key={child.id}>{this.renderTreeNode(child)}</li>
              ))}
            </ul>
          )}
        </div>
      );
    } else {
      return (
        <this.FolderItem
          key={node.id}
          folder={node}
          onRename={this.handleRenameFolder}
          onDelete={this.handleDeleteFolder}
          onDrop={this.handleDropFileToFolder}
          onRemoveChild={this.handleRemoveChild}
        />
      );
    }
  }

  return <this.FileItem file={node} />;
};

    convertToFolderTree = (data) => {
      return data.map((talent) => {
        return {
          id: talent.talent_id,
          name: talent.talent_name,
          profile_image_path : talent.profile_image_path,
          age : talent.talent_age,
          mobile_no : talent.talent_mobile_no,
          email : talent.talent_email,
          nationality : talent.talent_nationality,
          talent_rating : talent.talent_rating,
          notes : talent.talent_notes,
          type: "folder",
          isOpen : talent.selected,
          children: talent.voice_data.map((voice) => ({
            talent_id: talent.talent_id,
            talent_name: talent.talent_name,
            sample_id: voice.sample_id,
            name: voice.fileName,
            type: "file",
            filePath: voice.voice_path,
            fileType: voice.fileType,
            voiceModulationPath: voice.voice_modulation_path,
            tags: voice.tags,
          })),
        };
      });
    };

    convertToFolderTree2 = (data) => {
      return data.map((folder) => {
        return {
          id: folder.folderId,
          name: folder.folderName,
          type: "folder",
          isDeleted: false,
          children:
            folder.voiceModel &&
            folder.voiceModel.map((sample) => ({
              talent_id: sample.talentId,
              sample_id: sample.sampleId,
              name: sample.voiceName,
              type: "file",
              filePath:
                process.env.REACT_APP_BASE_URL + "/" + sample.samplePath,
              isDeleted: false,
              isClientSelected: sample.isClientSelected,
            })),
        };
      });
    };

    convertToFolderTreeYears = (data) => {
      return data.map((year) => {
        return {
          id: year.id,
          name: year.name,
          type: year.type,
          value: year.value,
          category : year.category,
          isDeleted :false,
          isOpen : year.isOpen,
          parent: null,
          children: year.children?.map((client) => ({
            id: client.name,
            name: client.name,
            value : client.name,
            year : client.year,
            type: "folder",
            parent: year,
            isDeleted :false,
            isOpen : client.isOpen,
            category: "client",
            children: client.children?.map((project) => ({
              id: project.id,
              name: project.name,
              type: "folder",
              value : project.id,
              client : project.name,
              parent: client,
              isDeleted :false,
              category : "project",
              isOpen : project.isOpen,
              children: project.children
            }))
          })),
        };
      });
    };
    handleShareProject = (projectId)=> {
      let url =
        process.env.REACT_APP_REDIRECT_URL +
        "/shared-projects/view/" +
        projectId;

      this.setState({
        showShareProjectModal: true,
        shareProjectLink: url,
      });
    };

    handleDeleteProject = (node)=> {
      this.setState({ showDeleteModal : true, currDeleteProject : node.id});

    };
    showDeleteClientPopup  = (node)=> {
      this.setState({ showDeleteClientModal : true, currDeleteClient : node});



    };
    showEditProjectPopup  = (node)=> {
      this.setState({ showEditProjectModal : true, currEditProject : node, currEditProjectName : node.name});


    };
    showEditClientPopup  = (node)=> {
      this.setState({ showEditClientModal : true, currEditClient : node, currEditClientName : node.name});


    };


   handleCreateFolder = (projectId) => {
  const newFolderId = Date.now().toString();

  this.setState((prevState) => {
    let folderCount = 1;

    // Step 1: Find the target project to determine folder count
    prevState.rightPanelFolders.forEach((yearFolder) => {
      yearFolder.children.forEach((client) => {
        client.children.forEach((project) => {
          if (project.id === projectId) {
            folderCount = project.children.length + 1;
          }
        });
      });
    });

    const newFolder = {
      id: newFolderId,
      name: prevState.newFolderName || `NewFolder${folderCount}`,
      type: "folder",
      category: "project-folder",
      children: [],
      isDeleted: false,
      isNew: true,
    };

    // Step 2: Build updated state
    const updatedFolders = prevState.rightPanelFolders.map((yearFolder) => {
      const updatedClients = yearFolder.children.map((client) => {
        const updatedProjects = client.children.map((project) => {
          if (project.id === projectId) {
            this.setShowSaveProject(true);
            return {
              ...project,
              children: [...project.children, newFolder],
              folderCount,
            };
          }
          return project;
        });

        return {
          ...client,
          children: updatedProjects,
        };
      });

      return {
        ...yearFolder,
        children: updatedClients,
      };
    });

    return {
      rightPanelFolders: updatedFolders,
      newFolderName: `NewFolder${folderCount}`,
    };

  });

};

handleCreateProjectFolder = (node) => {
  if(!node)
  {
     projectStore.setCreateNewProjectModalVisibleV2(true, {

                  });
    return;
  }
 projectStore.setCreateNewProjectModalVisibleV2(true, {
                    clientName: node.id,
                    year: node.year
                  });
  projectStore.setParentNode(node.id, node.category, node.year);
};
handleCreateClientFolder = (node) => {
  projectStore.setCreateNewProjectModalVisibleV2(true, {
                    year: node.value,
                  });
                  projectStore.setParentNode(node.id, node.category, node.value);
};


    handleRenameFolder = (folderId, newName) => {
  this.setState((prevState) => {
    const updatedFolders = prevState.rightPanelFolders.map((folder) => {
      const updatedClients = folder.children.map((client) => {
        const updatedProjects = client.children.map((project) => {
          const updatedProjectFolders = project.children.map((projectFolder) => {
            if (projectFolder.id === folderId) {
              this.setShowSaveProject(newName !== projectFolder.name);
              return {
                ...projectFolder,
                name: newName, // ✅ Rename here
              };
            }
            return projectFolder;
          });

          return {
            ...project,
            children: updatedProjectFolders,
          };
        });

        return {
          ...client,
          children: updatedProjects,
        };
      });

      return {
        ...folder,
        children: updatedClients,
      };
    });

    return {
      rightPanelFolders: updatedFolders,
    };
  });
};


    handleDeleteFolder = (id) => {
  const updatedFolders = this.state.rightPanelFolders.map((yearFolder) => ({
    ...yearFolder,
    children: (yearFolder.children || []).map((clientFolder) => ({
      ...clientFolder,
      children: (clientFolder.children || []).map((projectFolder) => {
        const updatedChildren = (projectFolder.children || [])
          .map((child) => {
            if (child.id !== id) return child;

            return child.isNew ? null : { ...child, isDeleted: true };
          })
          .filter(Boolean); // Remove nulls

        return { ...projectFolder, children: updatedChildren };
      }),
    })),
  }));

  this.setState({ rightPanelFolders: updatedFolders }, () => {
    this.checkProjectChanges(updatedFolders);
  });
};


    handleDiscardDeleteFolder = (id) => {
  const updatedFolders = this.state.rightPanelFolders.map((folder) => {
    const updatedClients = (folder.children || []).map((clientFolder) => {
      const updatedProjects = (clientFolder.children || []).map((projectFolder) => {
        let shouldUpdate = false;

        const updatedSubFolders = (projectFolder.children || []).map((subFolder) => {
          if (subFolder.id === id) {
            shouldUpdate = true;
            if (subFolder.isNew) {
              return null; // Remove it if it's a new subfolder
            }
          }
          return { ...subFolder, isDeleted: false };
        }).filter(Boolean); // remove nulls

        return shouldUpdate
          ? { ...projectFolder, isDeleted: false, children: updatedSubFolders }
          : { ...projectFolder };
      });

      return { ...clientFolder, children: updatedProjects };
    });

    return { ...folder, children: updatedClients };
  });
  this.checkProjectChanges(updatedFolders);
  this.setState({ rightPanelFolders: updatedFolders });
};


    handleDropFileToFolder = (file, folderId) => {
  this.setState((prevState) => {
    const updatedFolders = prevState.rightPanelFolders.map((folder) => {
      const updatedChildren = folder.children.map((client) => {
        const updatedProjects = client.children.map((project) => {
          const updatedProjectFolders = project.children.map((projectFolder) => {
            if (projectFolder.id === folderId) {
              const fileExists = projectFolder.children.some(
                (child) => child.sample_id === file.sample_id
              );

              if (fileExists) {
                toast.warning("File already exists in the folder");
                return projectFolder;
              }
              let newFile = { ...file };
              newFile.isNew = true;
              this.setShowSaveProject(true);
              return {
                ...projectFolder,
                children: [...projectFolder.children, newFile],
              };
            }
            return projectFolder;
          });

          return {
            ...project,
            children: updatedProjectFolders,
          };
        });

        return {
          ...client,
          children: updatedProjects,
        };
      });

      return {
        ...folder,
        children: updatedChildren,
      };
    });

    return { rightPanelFolders: updatedFolders };
  });

};

    handleRemoveChild = (folderId, sampleId) => {
  this.setState((prevState) => {
    const updatedFolders = prevState.rightPanelFolders.map((folder) => {
      const updatedClients = folder.children.map((client) => {
        const updatedProjects = client.children.map((project) => {
          const updatedProjectFolders = project.children.map((projectFolder) => {
            if (projectFolder.id === folderId) {
              const updatedChildren = projectFolder.children
                .filter((child) => {
                  // Remove if child is not marked deleted and matches sampleId
                  return !(child.isDeleted === undefined && child.sample_id === sampleId);
                })
                .map((child) => {
                  // Mark as deleted if it matches and not yet deleted
                  if (child.isDeleted === false && child.sample_id === sampleId) {

                    return { ...child, isDeleted: true };
                  }
                  return child;
                });

              return {
                ...projectFolder,
                children: updatedChildren,
              };
            }
            return projectFolder;
          });

          return {
            ...project,
            children: updatedProjectFolders,
          };
        });

        return {
          ...client,
          children: updatedProjects,
        };
      });

      return {
        ...folder,
        children: updatedClients,
      };
    });
    this.checkProjectChanges(updatedFolders);
    return { rightPanelFolders: updatedFolders };
  });
};

   handleDiscardRemoveChild = (folderId, sampleId) => {
  const updatedFolders = this.state.rightPanelFolders.map((folder) => {
    const updatedClients = (folder.children || []).map((clientFolder) => {
      const updatedProjects = (clientFolder.children || []).map((projectFolder) => {
        let shouldUpdate = false;

        const updatedChildren = (projectFolder.children || []).map((childFolder) => {
          if (childFolder.id !== folderId) return childFolder;

          const updatedFiles = (childFolder.children || []).map((file) => {
            if (file.sample_id === sampleId) {
              shouldUpdate = true;
              return file.isNew ? null : { ...file, isDeleted: false };
            }
            return file;
          }).filter(Boolean);

          return { ...childFolder, children: updatedFiles };
        });

        return shouldUpdate
          ? { ...projectFolder, isDeleted: false, children: updatedChildren }
          : { ...projectFolder };
      });

      return { ...clientFolder, children: updatedProjects };
    });

    return { ...folder, children: updatedClients };
  });

  this.checkProjectChanges(updatedFolders);
  this.setState({ rightPanelFolders: updatedFolders });
};


renderGroupedTalents() {
      return voiceStore.searchResults.map((talent, index) => {
        const isExpanded = this.state.expandedGroups[index];
        return (
          <div key={talent.talent_id} className="flex flex-col my-2">
            <button
              onClick={() => this.toggleGroup(index)}
              className="flex flex-1 flex-row gap-x-2 lg:gap-x-4 justify-center items-center pl-5"
            >
              <span className="font-medium text-xs lg:text-base text-black flex flex-1">
                {talent.talent_name}
              </span>
              <span className="font-normal text-xs text-white py-1 px-2 rounded-full bg-[#F89A1F]">
                {talent.voice_data.length}
              </span>
              {isExpanded ? (
                <FaCaretDown size={20} />
              ) : (
                <FaCaretRight size={20} />
              )}
              <div className="h-[1.5px] w-[50%] md:w-[80%] bg-[#B7B7B7]"></div>
            </button>

            {isExpanded &&
              talent?.voice_data.map((voice, index) => (
                <div
                  key={talent.talent_id + index}
                  className="flex flex-1 flex-row justify-between items-center border border-l-0 my-2 py-2 px-10"
                >
                  <div className="flex flex-1 flex-row gap-2 items-center">
                    {talent.profile_image_path ? (
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/" +
                          talent.profile_image_path
                        }
                        className="w-10 h-10 rounded-full"
                        alt={talent?.talent_name}
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-gray-200 flex justify-center items-center text-sm text-black/50">
                        {generalStore.getInitials(talent.talent_name)}
                      </div>
                    )}
                    <div className="flex flex-col justify-center">
                      <span className="font-normal text-sm text-[#21272A]">
                        {voice.tags.accent[0] ? voice.tags.accent[0] : voice.fileName}
                        {console.log(typeof voice.tags.accent)}
                      </span>
                      <span className="font-normal text-xs text-[#697077]">
                        {talent?.talent_name}
                      </span>
                    </div>
                  </div>

                  {/* Conditionally render description based on screen width */}
                  {this.state.windowWidth >= 768 && (
                    <>
                      <div className="flex flex-1 flex-row justify-center items-center">
                        {voice.fileType === "mp4" ? (
                          <button
                            onClick={() => {
                              voiceStore.setVideoModal({
                                fileName: voice.fileName,
                                video: voice.voice_path,
                              });
                            }}
                            className="text-blue-500 underline underline-offset-2"
                          >
                            show video
                          </button>
                        ) : (
                          <Wave
                            clickable={false}
                            id={`${talent.talent_id}-${index}`}
                            audioUrl={voice.voice_path}
                            peaksUrl={voice.voice_modulation_path}
                          />
                        )}
                      </div>
                      <div className="flex flex-1 justify-center">
                        <div className="font-normal text-xs text-[#121619] ml-3">
                          {Object.keys(voice.tags).map((key) => (
                            <div key={key}>
                              {voice.tags[key].map((item, index) => (
                                <span key={index}>
                                  {item} {item && "/"}
                                </span>
                              ))}
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="flex flex-row gap-x-3">
                    {voiceStore.isPlaying &&
                    voiceStore.currentVoice?.voice_path === voice.voice_path ? (
                      <button
                        onClick={() => {
                          voiceStore.togglePlayPause(false);
                        }}
                      >
                        <LuPause
                          className="fill-black hover:cursor-pointer"
                          size={18}
                        />
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          if (voice.fileType === "mp4") {
                            voiceStore.setVideoModal({
                              fileName: voice.fileName,
                              video: voice.voice_path,
                            });
                            return;
                          }
                          if (
                            voiceStore.currentVoice?.voice_path ===
                            voice.voice_path
                          ) {
                            voiceStore.togglePlayPause(true);
                            return;
                          }
                          voiceStore.setCurrentVoice(null);

                          setTimeout(() => {
                            voiceStore.setCurrentVoice({
                              talent_id: talent.talent_id,
                              talent_name: talent.talent_name,
                              voice_path: voice.voice_path,
                              voice_modulation_path:
                                voice.voice_modulation_path,
                              sample_id: voice.sample_id,
                              IsFavorite: voice.isFavorite,
                              profile_image_path: talent.profile_image_path,
                            });
                            voiceStore.togglePlayPause(true);
                          }, 500);
                        }}
                      >
                        <LuPlay
                          className="fill-black hover:cursor-pointer"
                          size={18}
                        />
                      </button>
                    )}

                    <LuHeart
                      onClick={this.handleFavoriteMusic(
                        voice.sample_id,
                        voice.isFavorite
                      )}
                      className={`hover:cursor-pointer hidden lg:flex ${
                        voice.isFavorite === "1" && "fill-[#F89A1F]"
                      }`}
                      size={18}
                    />
                    <LuFolderPlus
                      onClick={() => {
                        projectStore.setAddToProjectModalVisible(true);
                      }}
                      className="hover:cursor-pointer"
                      size={18}
                    />
                    <LuLayoutGrid
                      className="hover:cursor-pointer"
                      onClick={() => {
                        voiceStore.getTalentById(talent.talent_id).then(() => {
                          voiceStore.setTalentDetailsModalVisible(true);
                        });
                      }}
                      fill="black"
                      size={18}
                    />
                  </div>
                </div>
              ))}
          </div>
        );
      });
    }

    // renderRightPanelFolders = () => {
    //   console.log(this.state.rightPanelFolders);
    //   return this.state.rightPanelFolders.map((folder) => (

    //     <this.FolderItem
    //       key={folder.id}
    //       folder={folder}
    //       onRename={this.handleRenameFolder}
    //       onDelete={this.handleDeleteFolder}
    //       onDrop={this.handleDropFileToFolder}
    //       onRemoveChild={this.handleRemoveChild}
    //     />

    //   ));
    // };



    FileItem = ({ file }) => {
      const [isPlaying] = React.useState(false);
      const [{ isDragging }, drag] = useDrag(() => ({
        type: "FILE",
        item: file,
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
        options: {
          dropEffect: "copy",
        },
      }));

      let ismp4 = file.fileType === "mp4" || file.name.includes("mp4");

      const handlePlayPause = () => {
        if (ismp4) {
          voiceStore.setCurrentVoice(null);
          voiceStore.setVideoModal({
            video: file.filePath,
            fileName: file.name,
          });
        } else {
          voiceStore.setCurrentVoice(null);
          setTimeout(() => {
            voiceStore.setCurrentVoice({
              talent_id: file.talent_id,
              talent_name: file.talent_name ? file.talent_name : file.name,
              voice_path: file.filePath,
              voice_modulation_path: file.voiceModulationPath,
              sample_id: file.sample_id,
              IsFavorite: file.isFavorite,
            });
            voiceStore.togglePlayPause(true);
          }, 500);
        }
      };

      return (
        <>
          <button
            ref={drag}
            className={`flex flex-1 w-full flex-col lg:flex-row lg:justify-between lg:items-center  mt-1 mb-1 ${
              isDragging ? "opacity-50" : ""
            }`}
            onClick={handlePlayPause}
          >
            <div
              className={`flex flex-row justify-center items-center ${
                file.isDeleted && "line-through text-red-500"
              }`}
            >
              {isPlaying ? (
                <LuPauseCircle className="mr-2" size={20} />
              ) : ismp4 ? (
                <LuPlaySquare className="mr-2" size={20} />
              ) : (
                <LuPlayCircle className="mr-2" size={20} />
              )}
              <span className={`cursor-move font-normal text-xs`}>{file.name}</span>
              {file.isClientSelected === "True" && (
                <BsPersonFillCheck
                  className={`text-[#F89A1F] text-xl ml-2 tooltip`}
                />
              )}
              <Tooltip
                anchorSelect=".tooltip"
                content="This sound was selected by the client."
                style={{ fontSize: 12 }}
              />
            </div>

            <span className="flex flex-1 items-center flex-wrap justify-center ml-7 lg:ml-0">
              {file.tags &&
                Object.keys(file.tags).map((key, idx) => (
                  <div key={key} className="flex flex-wrap">
                    {file.tags[key].map((item, index) => (
                      <span className="text-xs text-gray-500" key={index}>
                        {item && idx !== 0 && " / "} {item}
                      </span>
                    ))}
                  </div>
                ))}
            </span>
          </button>
        </>
      );
    };

handleQueryChange = async (event) => {
      const qSearch = event.target.value;
      this.setState({highlightedIndex: -1});
      voiceStore.setSearchQuary(qSearch);
      if(qSearch === null || qSearch.trim() == "" || qSearch.length < 3)
        return;
      await axios.get('/api/Search?q='+qSearch)
          .then(async(response) => {
            if(response)
            {
              const cleanSuggestions = response.data.item2.map(str => str.replace(/<[^>]*>/g, ''));
              this.setState({ suggestions: cleanSuggestions});
            }

          })
          .catch((error) => {
            console.error("There was an error!", error);
          });


  };

handleSelect = (item) => {

    voiceStore.setSearchQuary(item);
    this.setState({suggestions :[], highlightedIndex :-1 });


  };
  setInitialSearchData = ()=>
{
    voiceStore.setInitialSearchResult([...voiceStore.searchResults]);
}
  handleFavoriteMusic = (sample_id, isFavorite) => () => {
      voiceStore.setFavoriteMusic(sample_id, isFavorite).then((isFavorite) => {
        voiceStore.searchResults = voiceStore.searchResults.map((talent) => {
          talent.voice_data = talent.voice_data.map((voice) => {
            if (voice.sample_id === sample_id) {
              voice.isFavorite = isFavorite;
            }
            return voice;
          });
          return talent;
        });
      });
    };
    handleSearch = async () => {
     voiceStore.setShowPinnedTalent(false);
    const searchQuery = voiceStore.searchQuery;
    if(searchQuery === null || searchQuery.trim() === "")
    {
      voiceStore.setLoadResult(true);
      voiceStore.setEmptySearchResult();
      voiceStore.setSearcKeyword(null);
     setTimeout(() => {
                  voiceStore.setLoadResult(false);
                  // your delayed code here
                }, 200);
      

    }else
    {
       voiceStore.setSearcKeyword(searchQuery);
     
    await axios.get('/api/Search?q='+searchQuery)
      .then(async(response) => {
        if(!response.data.item1 || response.data.item1.length === 0)
        {
          voiceStore.setEmptySearchResult();
          return;
        }
        const sampleIds = response.data.item1.map(s => s.sample_id);
        const uniqueSampleIds = [...new Set(sampleIds)];
        const payload = {
            sampleId : uniqueSampleIds
        };
        await voiceStore.searchVoice(payload, false);
        this.setInitialSearchData();
        if(response.data.item1)
        {
            voiceStore.setSearchNavVisible(true);
           
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    }


  };
    FolderItem = ({ folder, onRename, onDelete, onDrop, onRemoveChild }) => {
      const [{ isOver }, drop] = useDrop(() => ({
        accept: "FILE",
        drop: (item) => onDrop(item, folder.id),
        collect: (monitor) => ({
          isOver: monitor.isOver(),
        }),
      }));

      const [isEditing, setIsEditing] = React.useState(false);
      const [newFolderName, setNewFolderName] = React.useState(folder.name);
      const [originalFolderName, setOriginalFolderName] = React.useState(
        folder.name
      );

      const handleEditClick = () => {
        setIsEditing(true);

        setOriginalFolderName(newFolderName);
      };

      const handleInputChange = (e) => {
       setNewFolderName(e.target.value);
        folder.isEditing = folder.name != e.target.value;

      };

      const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          let onr = onRename(folder.id, newFolderName);
          if (onr === false) {
            setNewFolderName(originalFolderName);
          }
          setIsEditing(false);
        }
      };

      const handleBlur = () => {
        let onr = onRename(folder.id, newFolderName);
        if (onr === false) {
          setNewFolderName(originalFolderName);
        }
        setIsEditing(false);
      };



      return (
        <div
          ref={drop}
          key={folder.id}
          className={`flex flex-col p-2 ${
            isOver ? "bg-gray-100" : "bg-white"
          }  rounded-md group`}
        >
          <div className="flex items-center w-full"  onClick={() => this.toggleFolderByNode(folder)}>
            <LuFolderOpen

              size={20}
              className={`mr-2 ${
                folder.isDeleted && "line-through text-red-500"
              }`}
            />
            {isEditing ? (
              <input
                type="text"
                value={newFolderName}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
                autoFocus
                className="font-semibold border p-1 rounded"
              />
            ) : (
              <span
                className={`cursor-pointer ${
                  folder.isDeleted && "line-through text-red-500"
                }`}
              >
                {folder.name}
              </span>
            )}

            <div className="flex space-x-2 ml-4">

              {!folder.isDeleted ? (
                <>
                  <FaEdit
                    onClick={handleEditClick}
                    className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  />
                  <FaTrash
                    onClick={() => onDelete(folder.id)}
                    className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  />

                </>
              ) : (
                <FaUndo
                  onClick={() => this.handleDiscardDeleteFolder(folder.id)}
                  className="flex text-black cursor-pointer transition-all"
                />
              )}
            </div>
          </div>

          {/* Child Files */}
          {folder.children && folder.children.length > 0 && (
            <ul className="flex flex-col flex-1 w-full ml-4">
              {folder.children.map((child) => (
                <div
                  key={child.sample_id}
                  className="flex flex-1 w-full flex-row items-center gap-x-2"
                >
                  {child.isDeleted ? (
                    <FaUndo
                      onClick={() =>
                        this.handleDiscardRemoveChild(
                          folder.id,
                          child.sample_id
                        )
                      }
                      className="mr-2 cursor-pointer"
                    />
                  ) : (
                    <FaMinus
                      onClick={() => onRemoveChild(folder.id, child.sample_id)}
                      className="mr-2 cursor-pointer"
                    />
                  )}

                  <this.FileItem file={child} folder={folder} />
                </div>
              ))}
            </ul>
          )}
        </div>
      );
    };

    loadData = async (data) => {
      this.setState(() => ({
            rightPanelFolders: [],
            openFolders:[]
      }));
      await voiceStore.getDropdownData();
      let years = projectStore.years;
      let clients = [];
      if(years)
      {
        clients = years.map((year) => ({
            id: year,
            name: year,
            value : year,
            type: "folder",
            category: "year",
            children :[]
           
          }));
       
      }
      const payload = {
            favorite : true
        };
      await voiceStore.searchVoice(payload, true);
      voiceStore.setShowPinnedTalent(true);
      this.setInitialSearchData();
      this.setState({ clients : clients});

      setTimeout(() => {
        let fol = this.convertToFolderTreeYears(clients);

        fol.forEach((newFolder) => {
          
          this.setState((prevState) => ({
            rightPanelFolders: [...prevState.rightPanelFolders, newFolder],
          }));
         
          
        });
      }, 200);
    };

    copyToClipboard = (url) => {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          toast.info("Link copied to clipboard.");
        })
        .catch((error) => {
          toast.error("Failed to copy link to clipboard.");
        });
    };

    async componentDidMount() {
      voiceStore.setShowPinnedTalent(true);
       voiceStore.setSearchNavVisible(true);
       await  projectStore.getYears().then(() => {
                this.setState({ years: projectStore.years });
            });
      await this.loadData();

      const { location } = this.props;

      if (location.state) {
        const { projectName } = location.state;
        this.setState({ projectName: projectName });
      } else if (projectStore.projects.length > 0) {
        let project_name = projectStore.projects.find(
          (project) => project.project_id === this.props.params.projectId
        )?.project_name;
        this.setState({ projectName: project_name });
      } else {
        this.setState({ projectName: this.props.params.projectId });
      }

      document.addEventListener("keydown", this.handleKeyDown);
      document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
      document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
 
     
           if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ suggestions: [] }); // hide dropdown
    }
     if (
      this.modalRef.current &&
      !this.modalRef.current.contains(event.target)
    ) {
      this.setState({ showProfileDetailModal: false, currOpenProfile: null });
      
    }
    };
    handleKeyDown =(e)=>{
if (e.key === "Escape" && 
      this.modalRef.current &&
      !this.modalRef.current.contains(e.target)
    ) {
      this.setState({ showProfileDetailModal: false, currOpenProfile: null });
    }
    };

    handleSearchKeyDown = (e) => {
     
    const { highlightedIndex, suggestions } = this.state;
    
    if (e.key === "ArrowDown") {
      const selectedHighlighted =  highlightedIndex < suggestions.length - 1
            ? highlightedIndex + 1
            : 0;
       e.preventDefault();
      this.setState({
        highlightedIndex:selectedHighlighted
         
      });
   
     
      
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      this.setState({
        highlightedIndex:
          highlightedIndex > 0
            ? highlightedIndex - 1
            : suggestions.length - 1,
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        this.handleSelect(suggestions[highlightedIndex]);
         this.setState({ suggestions: [], highlightedIndex: -1 });
      } else {
        this.handleSearch(); // fallback to normal search
        this.setState({ suggestions: [], highlightedIndex: -1 });
      }
    } else if (e.key === "Escape") {
      this.setState({ suggestions: [], highlightedIndex: -1 });
      
    }
    
  };

    render() {
       const { loading, isMobile } = this.state;

      return (
        <div className="flex flex-1 flex-col p-0 lg:p-8">
         
                     <div>
                   {(
                       <div className="flex justify-center bg-gray-100 pt-0 gap-1">

                       <input
                           type="text"
                           className="border border-black/60 placeholder-black/80 rounded-md px-3 py-2 max-w-48 lg:w-full lg:max-w-lg"
                           placeholder="Search"
                           value={voiceStore.searchQuery}
                           onChange={this.handleQueryChange}
                          onKeyDown={this.handleSearchKeyDown}

                       />

  <button
  className="flex items-center justify-center bg-[#130D0D] rounded-md w-10 h-10"
  onClick={this.handleSearch}
>
  {voiceStore.loadResult ? (
    <Bars height={20} width={20} color="#F89A1F" visible={true} />
  ) : (
    <img src={SearchColoredIcon} alt="Search Icon" className="w-4 h-4" />
  )}
</button>





                       </div>


                   )}
                   </div>

                  <div className="flex justify-center bg-gray-100 pb-2 gap-1" ref={this.dropdownRef}>
          {this.state.suggestions.length > 0 && (
            <ul
              className="max-w-48 lg:w-full lg:max-w-lg bg-white"
              style={{
                border: '1px solid #ccc',
                padding: 0,
                margin: 0,
                marginLeft: '-52px',
                listStyle: 'none',
                position: 'absolute',
                zIndex: 1000,
              }}
            >
              {this.state.suggestions.map((item, index) => (
                <li
                  key={item}
                  onClick={() => this.handleSelect(item)}
                  style={{
                    padding: '8px',
                    cursor: 'pointer',
                    backgroundColor: index === this.state.highlightedIndex ? '#eee' : 'white',
                  }}
                >
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
          <div className="flex justify-end mx-6 py-1 gap-3 lg:gap-6"></div>
          <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
            <div className="flex flex-col lg:flex-row flex-wrap gap-2">
              
              {voiceStore.searchNavVisible && <SearchNavV2></SearchNavV2>}

              <div className={`flex flex-1 flex-col bg-white rounded-md pb-5`}>
                <div className="flex flex-row border-b">
                  <div className="flex flex-1 px-2 lg:h-14 rounded-md items-center mx-2 font-semibold">
                    
                   {voiceStore.showPinnedTalent ? "Pinned Talents" : "Search Result"} ({voiceStore.searchResults.length})
                  </div>

                </div>


               <div className="flex flex-1 relative pt-2">
  {voiceStore.loadResult ? (
    <div className="flex flex-1 justify-center items-center h-40">
      <ClipLoader loading={true} color="#36d7b7" size={35} />
    </div>
  ) : voiceStore.searchResults.length > 0 ? (
    this.renderTree(
      this.convertToFolderTree(voiceStore.searchResults)
    )
  ) : (
    <div className="flex flex-1 flex-col justify-center items-center gap-2">
      <span>No Data Found</span>
    </div>
  )}
</div>


              </div>

              <div className="hidden lg:flex h-screen w-[1px] bg-gray-400"></div>

              <div
                className={`flex flex-1 flex-col bg-white rounded-md pb-20 lg:p-0`}
              >
                <div className="flex flex-row border-b">
                  <div className="flex flex-1 px-2 lg:h-14 rounded-md items-center mx-2 font-semibold">
                    Project View
                  </div>
                  <Button
                    onClick={() => {
                      this.handleCreateProjectFolder()
                    }}
                    className="h-10 mt-2 mr-5 mb-2"
                    icon={AddNewTalentColoredIcon}
                    title={"Add New"}
                  />


                </div>
                {this.state.years.length > 0 ? (<div className="mt-2">{this.renderTreeProjects
                (this.state.rightPanelFolders)}

                      </div>): (
                  <div className="flex flex-1 flex-col justify-center items-center gap-2">

                    <span className="font-medium text-sm text-[#130D0D]">
                     No Projects
                    </span>
                  </div>
                )}

              </div>
             {this.state.showSaveProject && (<Button
                disabled={loading}
                onClick={this.handleSaveProject}

                className={`fixed bottom-3 right-5 ${
                  voiceStore.currentVoice && "!bottom-[4.5rem]"
                }  lg:flex lg:fixed lg:right-14 lg:bottom-10`}
                title={
                  loading ? (
                    <Bars
                      height="20"
                      width="25"
                      color="#F89A1F"
                      ariaLabel="bars-loading"
                      visible={loading}
                    />
                  ) : (
                    "Save Project"
                  )
                }
              />)}
            </div>
          </DndProvider>

          {/* Delete Modal */}
          {this.state.showDeleteModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <div className="flex flex-row justify-start items-center gap-x-2 mb-4">
                  <PiWarningCircleFill color="#F89A1F" />
                  <span className="font-normal text-sm">
                    Are you sure you want to delete this project?
                  </span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleDeleteModal}
                    className="border border-[#D9D9D9] bg-white rounded-sm"
                  >
                    <span className="font-normal text-sm px-3">No</span>
                  </button>
                  <button
                    onClick={() =>
                      this.handleDelete()
                    }
                    className="border border-black bg-black rounded-sm"
                  >
                    <span className="font-normal text-sm px-3 text-white">
                      Yes
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* Delete Client Modal */}
          {this.state.showDeleteClientModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <div className="flex flex-row justify-start items-center gap-x-2 mb-4">
                  <PiWarningCircleFill color="#F89A1F" />
                  <span className="font-normal text-sm">
                    Are you sure you want to delete this client?
                  </span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleDeleteClientModal}
                    className="border border-[#D9D9D9] bg-white rounded-sm"
                  >
                    <span className="font-normal text-sm px-3">No</span>
                  </button>
                  <button
                    onClick={
                      this.handleDeleteClient
                    }
                    className="border border-black bg-black rounded-sm"
                  >
                    <span className="font-normal text-sm px-3 text-white">
                      Yes
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Share Project Modal */}
          {this.state.showShareProjectModal && (
            <div className="z-50 fixed  inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white relative rounded-lg p-5 w-[90%] lg:w-2/5">
                <div className="flex flex-col gap-y-4">
                  <span className="font-bold text-3xl text-[#21272A]">
                    Share Via
                  </span>
                  <span className="font-normal text-base text-[#21272A]">
                    Share Project !
                  </span>
                </div>

                <div className="flex flex-row gap-x-12 justify-center mt-6">
                  <a
                    href="mailto:"
                    className="flex flex-col justify-center items-center gap-y-2"
                  >
                    <span className="p-4 bg-[#2222220F] rounded-full text-xl">
                      <LuMail></LuMail>
                    </span>
                    <span className="font-normal text-xs text-[#888888]">
                      Email
                    </span>
                  </a>

                  <button
                    onClick={() => {
                      this.copyToClipboard(this.state.shareProjectLink);
                      setTimeout(() => {
                        window.open("https://web.whatsapp.com", "_blank");
                      }, 500);
                    }}
                    className="flex flex-col justify-center items-center gap-y-2"
                  >
                    <span className="p-4 bg-[#2222220F] rounded-full text-xl">
                      <FaWhatsapp></FaWhatsapp>
                    </span>
                    <span className="font-normal text-xs text-[#888888]">
                      Whatsapp
                    </span>
                  </button>
                </div>

                <div className="flex flex-row justify-between items-center border p-3 mt-6">
                  <span className="font-normal text-sm text-[#8D9CA5] w-full overflow-hidden text-ellipsis whitespace-nowrap">
                    {this.state.shareProjectLink
                      ? this.state.shareProjectLink
                      : "The link could not be created"}
                  </span>
                  <button
                    disabled={this.state.shareProjectLink ? false : true}
                    onClick={() => {
                      this.copyToClipboard(this.state.shareProjectLink);
                    }}
                    className="text-base ml-3"
                  >
                    <LuCopy></LuCopy>
                  </button>
                  <button
                    disabled={this.state.shareProjectLink ? false : true}
                    onClick={() => {
                      window.open(this.state.shareProjectLink, "_blank");
                    }}
                    className="text-base ml-3"
                  >
                    <LuExternalLink></LuExternalLink>
                  </button>
                </div>

                <div className="flex flex-row justify-end gap-4 mt-6">
                  <Button
                    onClick={() => {
                      this.copyToClipboard(this.state.shareProjectLink);
                      this.toggleShareProjectModal();
                    }}
                    title="Share"
                  ></Button>
                </div>

                <button
                  onClick={() => {
                    this.toggleShareProjectModal();
                  }}
                  className="absolute right-7 top-5 text-xl"
                >
                  <FaTimes></FaTimes>
                </button>
              </div>
            </div>
          )}

          {/* Edit Modal */}
                    {this.state.showEditProjectModal && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                        <div className="bg-white rounded-lg p-5 w-[22rem]">
                          <h3 className="text-lg font-semibold mb-4">
                            Update Project Name
                          </h3>

                          <div className="mb-4">
                            <input
                              type="text"
                              value={this.state.currEditProjectName}
                              onChange={(e) => {
                                this.setState(() => ({
                                  currEditProjectName : e.target.value
                                }));
                              }}
                              className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md"
                            />
                          </div>

                          <div className="flex justify-end gap-4">
                            <button
                              onClick={this.toggleEditProjectModal}
                              className="border border-gray-300 bg-white px-3 py-2 rounded-xl"
                            >
                              Cancel
                            </button>
                            <Button onClick={this.handleRenameProject} title="Update"></Button>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.showEditClientModal && (
                                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                                  <div className="bg-white rounded-lg p-5 w-[22rem]">
                                    <h3 className="text-lg font-semibold mb-4">Update Client</h3>

                                    <div className="mb-4">
                                      <input
                                        type="text"
                                        value={this.state.currEditClientName}
                              onChange={(e) => {
                                this.setState(() => ({
                                  currEditClientName : e.target.value
                                }));
                              }}
                                        className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md"
                                      />
                                    </div>

                                    <div className="flex justify-end gap-4">
                                      <button
                                        onClick={this.toggleEditClientModal}
                                        className="border border-gray-300 bg-white px-3 py-2 rounded-xl"
                                      >
                                        Cancel
                                      </button>
                                       <Button onClick={this.handleRenameClient} title="Update"></Button>
                                    </div>
                                  </div>
                                </div>
                              )}
     {/* detail profile Modal */}
                              {this.state.showProfileDetailModal && (
 
<div  className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
  <div ref={this.modalRef} className="relative bg-white rounded-lg p-5 w-[22rem]">
    {/* ❌ Close button */}
    <button
      className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl font-bold"
      onClick={() =>
        this.setState({ showProfileDetailModal: false, currOpenProfile: null })
      }
    >
      &times;
    </button>

    {/* 👤 Avatar + details */}
    <div className="flex items-center space-x-3 mb-4">
      {this.state.currOpenProfile?.profile_image_path ? (
        <img
          src={`${process.env.REACT_APP_BASE_URL}/${this.state.currOpenProfile.profile_image_path}`}
          className="w-10 h-10 rounded-full"
          alt={this.state.currOpenProfile.name}
        />
      ) : (
        <div className="w-10 h-10 rounded-full bg-gray-200 flex justify-center items-center text-sm text-black/50">
          {generalStore.getInitials(this.state.currOpenProfile.name)}
        </div>
      )}

      {/* Name, e-mail, phone, rating */}
      <div className="flex flex-col">
        <strong className="text-lg">{this.state.currOpenProfile?.name}</strong>

      
<div className="flex items-center gap-0.5">
  {Array.from({ length: 5 }).map((_, i) => {
    const rating = this.state.currOpenProfile?.talent_rating ?? 0;
    if (rating >= i + 1) {
      return <FaStar key={i} className="text-yellow-400" />;
    } else if (rating >= i + 0.5) {
      return <FaStarHalfAlt key={i} className="text-yellow-400" />;
    } else {
      return <FaRegStar key={i} className="text-gray-300" />;
    }
  })}
</div>
{this.state.currOpenProfile?.mobile_no && (
                        <div className="flex items-center gap-2">
                          <span className="font-normal text-sm text-[#697077]">
                            <strong>Phone: </strong>
                            {this.formatData(this.state.currOpenProfile?.mobile_no)}
                          </span>
                          <a href={`https://wa.me/${this.state.currOpenProfile?.mobile_no}`} target="_blank">
                            <FaWhatsapp className="text-[#25D366]" />
                          </a>
                        </div>
                      )}
                      {this.state.currOpenProfile?.email && (
                        <span className="font-normal text-sm text-[#697077]">
                          <strong>Email: </strong>
                          <a
                            href={`mailto:${this.state.currOpenProfile?.email}`}
                            className="text-blue-500 underline"
                          >
                            {this.formatData(this.state.currOpenProfile?.email)}
                          </a>
                        </span>
                      )}
       
      </div>
    </div>

    {/* 📋 Profile info */}
    <div className="p-4 bg-[#F9FAFB] space-y-2 rounded">
      <p>
        <strong>Age:</strong>{" "}
        {this.formatData(
          this.state.currOpenProfile?.age
            ? this.calculateAge(this.state.currOpenProfile.age)
            : this.state.currOpenProfile?.age
        )}
      </p>
      <p>
        <strong>Nationality:</strong>{" "}
        {this.formatData(this.state.currOpenProfile?.nationality)}
      </p>
      <p>
        <strong>Notes:</strong>{" "}
        {this.formatData(this.state.currOpenProfile?.notes)}
      </p>
    </div>
  </div>
</div>


)}

          

                     {projectStore.createNewProjectModalVisibleV2 && <CreateProjectModalV2  onProjectCreated={this.refreshFolder}  />}

     
    
        </div>
      );
    }
  }
);

export default withRouter(Dashboard);
